<template>
    <modal name="teamlink-create-modal" adaptive height="auto">
        <div class="scc-teamlink-create-modal">
            <h3 class="scc-teamlink-create-modal__title">Teamlink aanmaken</h3>
            <p class="scc-teamlink-create-modal__description">
                Maak hier een team aan en strijd als één team voor je club!
            </p>
            <form action="submit" @submit.prevent="onSubmit">
                <AlternateFormTeamName v-model="form.name" label="Teamnaam" />
                <AlternateFormEmail v-model="form.email" label="Jouw e-mail adres voor de teamcaptain mails" />
                <FormCheckbox v-model="form.optInAge" name="optInMarketing" label="Mijn teamleden en ik zijn 18+" />
                <button type="submit" class="scc-teamlink-create-modal__button">
                    <span v-if="loading">loading...</span>
                    <span v-else>
                        Teamlink aanmaken
                    </span>
                </button>
            </form>
        </div>
    </modal>
</template>

<script>
import './teamlink-create-modal.scss';
import AlternateFormEmail from '../form/AlternateFormEmail';
import AlternateFormTeamName from '../form/AlternateFormTeamName';
import FormCheckbox from '../form/FormCheckbox';
import { setStorage } from '../../utils/storage';

export default {
    name: 'TeamlinkCreateModal',
    components: {
        AlternateFormEmail,
        FormCheckbox,
        AlternateFormTeamName,
    },
    props: {
        game: {
            type: Object,
            required: true,
        },
        identifier: {
            type: String,
        },
    },
    data() {
        return {
            error: false,
            loading: false,
            form: {
                name: '',
                email: '',
                optInAge: false,
            },
        };
    },
    methods: {
        show(identifier) {
            if (identifier === this.identifier) this.$modal.show('teamlink-create-modal');
        },
        hide() {
            this.$modal.hide('teamlink-create-modal');
        },
        onSubmit() {
            this.loading = true;
            this.$api
                .createAffiliate({ gameId: this.game.id, ...this.form, memberCount: 1 })
                .then(createAffiliate => {
                    if (createAffiliate.affiliate.id) {
                        setStorage('affiliate', createAffiliate.affiliate.id);

                        this.$router.push({
                            name: 'Page',
                            params: { path: 'team' },
                            query: { affiliate_id: createAffiliate.affiliate.id },
                        });
                    } else {
                        this.error = true;
                    }
                })
                .catch(() => {
                    this.error = true;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
